<template>
<section class="vpn-section compare">
  <div class="vpn-section__inner">
    <h2 class="vpn-section__title">{{ compareTitle }}</h2>
    <p class="vpn-section__lead">{{ compareLead }}</p>
    <p class="compare__note">{{ compareNote }}</p>

    <div class="compare__table-wrap">
      <table class="compare__table">
        <thead>
          <tr>
            <th v-for="header in compareHeaders" :key="header">{{ header }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in compareRows" :key="row.feature">
            <td>{{ row.feature }}</td>
            <td>{{ row.vpn }}</td>
            <td>{{ row.proxy }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
</template>

<script>
import homeLocaleContent from '@/mixins/homeLocaleContent';

export default {
  name: 'CompareSection',
  mixins: [homeLocaleContent],
  computed: {
    compareTitle() {
      return this.homeLocale?.compareTitle || 'Secure VPN App vs Free Web Proxy Online';
    },
    compareLead() {
      return (
        this.homeLocale?.compareLead ||
        'A Secure VPN App and a free web proxy both help users access the internet with more privacy, but they work in different ways. A VPN app creates an encrypted connection for your entire device, helping protect your online activity across browsers, apps, and networks.'
      );
    },
    compareNote() {
      return (
        this.homeLocale?.compareNote ||
        'A free web proxy usually works only through a browser. It can be useful for quick access to blocked websites or simple browsing needs, but it does not provide the same level of device-wide protection and encryption as a VPN.'
      );
    },
    compareHeaders() {
      return this.homeLocale?.compareHeaders || ['Feature', 'Secure VPN App', 'Free Web Proxy Online'];
    },
    compareRows() {
      return this.homeLocale?.compareRows || this.defaultRows;
    },
  },
  data() {
    return {
      defaultRows: [
        {
          feature: 'Protection Scope',
          vpn: 'Covers your entire device',
          proxy: 'Usually only works in a browser',
        },
        {
          feature: 'Encryption',
          vpn: 'Advanced encrypted connection',
          proxy: 'Limited or depends on the proxy service',
        },
        {
          feature: 'Privacy Protection',
          vpn: 'Protects online activity across apps',
          proxy: 'Mainly hides browser traffic',
        },
        {
          feature: 'Speed & Stability',
          vpn: 'Optimized VPN servers',
          proxy: 'May be slower or less reliable',
        },
        {
          feature: 'Best For',
          vpn: 'Daily browsing, streaming, public Wi-Fi protection',
          proxy: 'Quick temporary browsing',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/vpn-sections.scss';

.compare {
  // 底部收紧，让下方 H3 贴着表格
  padding-bottom: 8px;

  .vpn-section__title,
  .vpn-section__lead {
    text-align: left;
    max-width: none;
    margin-left: 0;
    margin-right: 0;
  }

  // 导语后还有补充说明，先收紧段间距，再由 note 统一留出 32px
  .vpn-section__lead {
    margin-bottom: 12px;
  }
}

.compare__note {
  margin: 0 0 32px;
  max-width: none;
  text-align: left;
  color: var(--vpn-ink-muted, #5b6475);
  font-size: 15px;
  line-height: 1.6;
}

.compare__table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 16px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  background: #fff;
  box-shadow: 0 10px 28px rgba(109, 74, 255, 0.06);
}

.compare__table {
  width: 100%;
  border-collapse: collapse;
  min-width: 560px;

  th,
  td {
    padding: 16px 18px;
    text-align: left;
    font-size: 14px;
    line-height: 1.5;
    border-bottom: 1px solid var(--vpn-line, #e8e4f8);
  }

  th {
    background: rgba(109, 74, 255, 0.08);
    color: var(--vpn-ink, #1f2430);
    font-weight: 700;
  }

  td:first-child {
    font-weight: 600;
    color: var(--vpn-ink, #1f2430);
    width: 22%;
  }

  td {
    color: var(--vpn-ink-muted, #5b6475);
  }

  tr:last-child td {
    border-bottom: 0;
  }
}

@media (max-width: 768px) {
  .compare__table-wrap {
    margin: 0 -2px;
    padding-bottom: 4px;
  }

  .compare__table {
    min-width: 480px;

    th,
    td {
      padding: 11px 12px;
      font-size: 13px;
    }

    td:first-child {
      width: auto;
      white-space: nowrap;
    }
  }
}
</style>
